import { TableCell, useTheme } from '@mui/material';

interface CerebroStatusIndicatorTableCellProps {
	colorType: StatusIndicatorColor;
	tooltip: string;
}

export const CerebroStatusIndicatorTableCell: React.FC<CerebroStatusIndicatorTableCellProps> = ({
	colorType,
	tooltip,
}) => {
	const theme = useTheme();

	const getColorFromType = (colorType: StatusIndicatorColor): string => {
		switch (colorType) {
			case 'Green':
				return theme.palette.green.main;
			case 'Yellow':
				return theme.palette.primary.main;
			case 'Red':
				return theme.palette.error.main;
			case 'Blue':
				return theme.palette.info.main;
		}
	};

	return (
		<TableCell
			title={tooltip}
			sx={{ width: '5px', padding: '0px', cursor: 'help', backgroundColor: getColorFromType(colorType) }}
		>
			&nbsp;
		</TableCell>
	);
};

export type StatusIndicatorColor = 'Green' | 'Yellow' | 'Red' | 'Blue';
